import { observer } from 'mobx-react-lite'
import {
  AssignFileTypeDialog,
  AssignFileTypeEntry,
  type AssignFileTypeSelectOption,
} from '@/features/docs/components/AssignFileTypeDialog/index'
import {
  type AssignFileTypeDialogViewModel,
  type AssignmentEntryViewModel,
} from '@/features/docs/components/AssignFileTypeDialog/AssignFileTypeDialogViewModel'
import { Id } from '@/infra/id'

interface AssignFileTypeDialogContainerProps {
  vm: AssignFileTypeDialogViewModel
}

/**
 * Container for {@link AssignFileTypeDialog}.
 */
export const AssignFileTypeDialogContainer = observer(
  function AssignFileTypeDialogContainer({
    vm,
  }: AssignFileTypeDialogContainerProps) {
    const options: AssignFileTypeSelectOption[] = vm.availableTypes.map(
      (t) => ({
        id: Id.assert(t.id),
        displayName: t.name,
      }),
    )

    return (
      <AssignFileTypeDialog
        isOpen={Boolean(vm.currentRequest)}
        onClose={vm.cancel}
        onUpload={vm.confirm}
      >
        {vm.currentRequest?.entries.map((entry, idx) => (
          <AssignFileTypeEntryContainer
            vm={vm}
            options={options}
            key={idx}
            entryVm={entry}
          />
        ))}
      </AssignFileTypeDialog>
    )
  },
)

interface AssignFileTypeEntryContainerProps {
  vm: AssignFileTypeDialogViewModel
  entryVm: AssignmentEntryViewModel
  options: AssignFileTypeSelectOption[]
}

/**
 * Container for {@link AssignFileTypeEntry}.
 */
export const AssignFileTypeEntryContainer = observer(
  function AssignFileTypeEntryContainer({
    vm,
    entryVm,
    options,
  }: AssignFileTypeEntryContainerProps) {
    return (
      <AssignFileTypeEntry
        options={options}
        fileName={entryVm.file.name}
        value={entryVm.type?.id}
        onRemove={entryVm.remove}
        isSkeleton={vm.listTypes.pending}
        onChange={(newId) => {
          const type = vm.availableTypes.find((t) => t.id === newId)
          if (type) {
            entryVm.setType(type)
          }
        }}
      />
    )
  },
)
